module.exports = __webpack_public_path__ + "static/media/019-Kissen_ID_35.2e17e328.mp3";